import { render, staticRenderFns } from "./amountInput.vue?vue&type=template&id=297ccb7c&scoped=true&"
import script from "./amountInput.vue?vue&type=script&lang=ts&"
export * from "./amountInput.vue?vue&type=script&lang=ts&"
import style0 from "./amountInput.vue?vue&type=style&index=0&id=297ccb7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297ccb7c",
  null
  
)

export default component.exports